import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import { AuthCard } from "@/components/auth-card";
import { FormField } from "@/components/form-field";
import { Alert } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { errorMessage, login } from "@/lib/api";
import { meQuery, safeRedirect } from "@/lib/auth";

/** `/anmelden` (AUTH-01). */
export function LoginPage({ redirect }: { redirect?: string }) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const mutation = useMutation({
    mutationFn: () => login(email, password),
    onSuccess: async (me) => {
      queryClient.clear();
      queryClient.setQueryData(meQuery.queryKey, me);
      await navigate({ to: safeRedirect(redirect) });
    },
  });

  return (
    <AuthCard title="Anmelden" description="Mit der E-Mail-Adresse, an die die Einladung ging.">
      <form
        className="grid gap-4"
        onSubmit={(e) => {
          e.preventDefault();
          mutation.mutate();
        }}
      >
        {mutation.isError && <Alert variant="destructive">{errorMessage(mutation.error)}</Alert>}
        <FormField
          label="E-Mail"
          type="email"
          autoComplete="username"
          required
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <FormField
          label="Passwort"
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button type="submit" disabled={mutation.isPending}>
          {mutation.isPending ? "Wird angemeldet …" : "Anmelden"}
        </Button>
        <Link
          to="/passwort-vergessen"
          className="text-center text-sm text-muted-foreground underline-offset-4 hover:underline"
        >
          Passwort vergessen?
        </Link>
      </form>
    </AuthCard>
  );
}
